import { render, staticRenderFns } from "./footerContainer.vue?vue&type=template&id=5aec824a"
import script from "./footerContainer.vue?vue&type=script&lang=js"
export * from "./footerContainer.vue?vue&type=script&lang=js"
import style0 from "./footerContainer.vue?vue&type=style&index=0&id=5aec824a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports